import Vue from 'vue';
import FixHeight from './FixHeight';
import Payment from './Payment';
import Tooltip from './Tooltip';
import ScrollTo from './ScrollTo';
import Follow from './Follow';
import Uncloak from './Uncloak';
import Value from './Value';

/**
 * Export any directives that should be autoloaded
 * (resources/assets/js/app.js)
 */
export const defaultDirectives = {
    'fix-height': FixHeight,
    Payment,
    Tooltip,
    ScrollTo,
    Follow,
    Uncloak,
    Value,
};

/**
 * Load global Vue Directives
 * usage: <input v-directive> e.g. <input v-datepicker>
 *
 * @param {Object} directives
 */
export const loader = (directives = defaultDirectives) => {
    Object.keys(directives).forEach((directive) => {
        Vue.directive(directive, directives[directive]);
    });
};
